import { ordersConstants } from "../../constants";

export function orders(state={}, action) {
  const {
    orders,
  } = state;
  switch (action.type) {
    case ordersConstants.LIST_ORDERS_REQUEST:
      return { isListingOrders: true };
    case ordersConstants.LIST_ORDERS_SUCCESS:
      return { orders: action.payload.data };
    case ordersConstants.LIST_ORDERS_FAILURE:
      return {};
    default:
      return state;
  }
}